export const ItemExcelForm = [
  {
    header: {
      header: 'ItemCategory',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'ItemName',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'Description',
      width: 40,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'UOMCode',
      width: 15,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'TaxSchemeName',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'GLAccountCode',
      width: 15,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'Remark',
      width: 40,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'IsAP',
      width: 10,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'IsGP',
      width: 10,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'VariancePercentage',
      width: 18,
    },
    dataType: 'number',
  },
  {
    header: {
      header: 'MarketPrice',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'LatestPurchasePrice',
      width: 18,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'DefaultSupplier',
      width: 20,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'IsCentralised',
      width: 12,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'IsInventory',
      width: 12,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'ABCClass',
      width: 12,
    },
    dataType: 'abcClass',
  },
  {
    header: {
      header: 'ShelfLife',
      width: 15,
    },
    dataType: 'number',
  },
  {
    header: {
      header: 'StandardCost',
      width: 15,
    },
    dataType: 'amount',
  },
];
